import React from 'react';
import styled from '@emotion/styled';
import { view } from 'react-easy-state';
import Plx from 'react-plx';
import { rgba } from 'polished';

import LLLStripe from '../images/lll-stripe.svg';
import LLLLogoText from '../images/lll-withtext.svg';
import mq from '../styles/mq';
import { colors } from '../styles/theme';
import { RedDot } from './elements';

@view
class Hero extends React.Component {
  render() {
    return (
      <section
        id="hero"
        className="section site-section"
        css={{ position: 'relative', overflow: 'hidden' }}
      >
        <a
          href="https://mahabbahmall.co"
          target="_blank"
          rel="noopener noreferrer"
          css={{
            position: 'absolute',
            top: 0,
            right: 0,
            padding: 16,
            fontWeight: 600,
            fontSize: 13,
            textTransform: 'uppercase',
            letterSpacing: 1,
            color: colors.pr.gray500,
          }}
        >
          Mahabbah Mall
        </a>
        <div
          css={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '100%',
            zIndex: -1,
            textAlign: 'center',
          }}
        >
          <LLLStripe
            preserveAspectRatio="none"
            css={{
              // position: 'absolute',
              // top: 0,
              // left: 'calc(50vw - 150px)',
              // zIndex: 1,
              opacity: 0.3,
              width: 300,
              height: '100%',
            }}
          />
          <div
            css={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '100%',
              background: `linear-gradient(to top, #fff, ${rgba('#fff', 0)})`,
              zIndex: 2,
            }}
          />
        </div>
        <div
          className="container"
          css={{
            maxWidth: '50rem',
            textAlign: 'center',
            padding: '10rem 0',
          }}
        >
          <Plx
            parallaxData={[
              {
                start: 100,
                end: 600,
                // easing: 'easeInOutExpo',
                properties: [
                  { property: 'translateY', startValue: 0, endValue: 300 },
                  { property: 'opacity', startValue: 1, endValue: 0 },
                ],
              },
            ]}
          >
            <LLLLogoText
              css={{
                width: 300,
                // background: '#fff',
                marginBottom: '4rem',
              }}
            />
          </Plx>

          <Plx
            parallaxData={[
              {
                start: 0,
                end: 300,
                // easing: 'easeInOutExpo',
                properties: [{ property: 'opacity', startValue: 1, endValue: 0 }],
              },
            ]}
          >
            <h2
              css={mq({
                fontSize: ['2.5rem', '3rem', '3.5rem'],
                lineHeight: 1,
                margin: '2rem 0 0',
              })}
            >
              <div>
                Learn to Love
                <RedDot />
              </div>

              <div>
                Love to Live
                <RedDot />
              </div>

              <div>
                Live to Learn and Love
                <RedDot />
              </div>
            </h2>
          </Plx>
          {/* <SubTitle size="1.5rem" css={{ color: colors.pr.gray600 }}>
            Live to Learn and Love
          </SubTitle> */}
          {/* <CTA type="button">Watch Video</CTA> */}
        </div>
      </section>
    );
  }
}

export default Hero;

const CTA = styled.button`
  margin-top: 2rem;
  background: ${colors.primary};
  color: #fff;
  border-radius: 2em;
  padding: 1em 1.75em;
  font-size: 1.25rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;
